// extracted by mini-css-extract-plugin
module.exports = {"SFranchiseBlockContent":"FranchiseBlockContent_SFranchiseBlockContent__ScSU9","SContentHeading":"FranchiseBlockContent_SContentHeading__JAYgC"};